import React from 'react';

import { InfoItem } from '@molecules';
import { useMedia } from '@api/hooks';
import { getImage } from '@utils/media';

const VideoItem = ({ video }) => {
  const { media } = useMedia(getImage(video, 'thumbnailImage'));

  const regexp = /src="([^"]+)"/i;
  const _url = regexp.exec(video.video);
  const url = _url?.[1];

  return (
    <InfoItem description={url} image={media.src}>
      {video.title}
    </InfoItem>
  );
};

export default VideoItem;
